import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { PayTermCalculationRequest } from "@/models/requests/payterm.interface";
import { PayTermCalculationResponse } from "@/models/responses/payterm.interface";
import { ApiService } from "./api.service";
import { SUSCRIPTION_KEY } from "@/constants/config";

class PayTermService extends ApiService {
  public constructor(config?: AxiosRequestConfig) {
    super(config);

    // this middleware is been called right before the http request is made.
    // this.api.interceptors.request.use((param: AxiosRequestConfig) => ({
    //   ...param
    // }));

    // this middleware is been called right before the response is get by the method that triggers the request
    // this.api.interceptors.response.use((param: AxiosResponse) => ({
    //   ...param
    // }));

    this.calculate = this.calculate.bind(this);
  }

  public calculate(request: Readonly<PayTermCalculationRequest>): Promise<PayTermCalculationResponse> {
    return this.post<PayTermCalculationResponse, PayTermCalculationRequest, AxiosResponse<PayTermCalculationResponse>>("Generics/version1/loan", request,
      {
        headers: {
          "Ocp-Apim-Subscription-Key": SUSCRIPTION_KEY
        }
      })
      .then(this.success)
      .catch((error: AxiosError<Error>) => {
        return Promise.reject(error);
      });
  }
}

export const paytermService = new PayTermService();
